// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2boyk","col":"styles_col__2FEwD"};